var map = {
	"./10-logo1.png": "9b22",
	"./10-logo10.png": "30f1",
	"./10-logo2.png": "b4c1",
	"./10-logo3.png": "be0c",
	"./10-logo4.png": "c5b1",
	"./10-logo5.png": "2f87",
	"./10-logo6.png": "2c32",
	"./10-logo7.png": "c3c4",
	"./10-logo8.png": "d499",
	"./10-logo9.png": "411f",
	"./cooperative_bg.png": "1c5b",
	"./jdlogo.png": "c40e",
	"./kingdee_logo.png": "5a48",
	"./partner_bg.png": "47c1",
	"./partner_icon.png": "64f6",
	"./youzan_logo.png": "18fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d14a";